import React, { memo, type ReactElement } from 'react';
import { Box, Chip } from '@saviynt/design-system';
import { format } from 'date-fns';

import { SodFieldSet } from '../../../../../shared/components';
import {
  useInvertedLocalize,
  useTypedSelector,
} from '../../../../../shared/hooks';

import './ViolationsTabDetailsMitigateSP.css';

/**
 * * TODO
 * - Write a description
 * - Chip should be dynamic
 */
function ViolationsTabDetailsMitigateSP(): ReactElement | null {
  const l = useInvertedLocalize();
  const { selectedRowData } = useTypedSelector(
    (state) => state.aag.details.violationsTab.mitigate
  );
  const {
    aag: {
      global: { globalDateFormat },
    },
  } = useTypedSelector((state) => state);

  if (!selectedRowData) {
    return null;
  }

  let priorityLevel: string;

  switch (String(selectedRowData.priority).toLowerCase()) {
    case 'high':
      priorityLevel = 'critical';
      break;
    case 'medium':
      priorityLevel = 'orange';
      break;
    default:
      priorityLevel = 'warning';
      break;
  }

  return (
    <Box className='Sod-ViolationsTabDetailsMitigateSP-layoutWidth'>
      {/* Section 1 */}
      <Box className='Sod-ViolationsTabDetailsMitigateSP-section'>
        {/* Row 1 */}
        <Box className='Sod-ViolationsTabDetailsMitigateSP-sectionRow'>
          <SodFieldSet
            label={l('Start Date')}
            value={format(
              new Date(selectedRowData.startDate),
              globalDateFormat
            )}
          />
          <SodFieldSet
            label={l('End Date')}
            value={format(new Date(selectedRowData.endDate), globalDateFormat)}
          />
        </Box>
        {/* Row 2 */}
        <Box className='Sod-ViolationsTabDetailsMitigateSP-sectionRow'>
          <SodFieldSet
            label={l('Mitigated by')}
            value={selectedRowData.approverName}
          />
        </Box>
      </Box>
      {/* Section 2 */}
      <Box className='Sod-ViolationsTabDetailsMitigateSP-section'>
        {/* Row 1 */}
        <Box className='Sod-ViolationsTabDetailsMitigateSP-sectionRow'>
          {selectedRowData.priority && (
            <SodFieldSet
              label={l('Priority')}
              value={
                <Chip
                  kind='subtleFilled'
                  label={selectedRowData.priority}
                  color={priorityLevel}
                  size='xSmall'
                  isInteractionDisabled
                />
              }
            />
          )}
          {selectedRowData.controlType && (
            <SodFieldSet
              label={l('Type')}
              value={selectedRowData.controlType}
            />
          )}
        </Box>
        {/* Row 2 */}
        <SodFieldSet
          label={l('Expires')}
          value={format(new Date(selectedRowData.expiryDate), globalDateFormat)}
        />
        {/* Row 3 */}
        {selectedRowData.description && (
          <SodFieldSet
            label={l('Description')}
            value={selectedRowData.description}
          />
        )}
      </Box>
    </Box>
  );
}

export default memo(ViolationsTabDetailsMitigateSP);
